// @mui material components
import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

// Presentation page sections
import InformationHome from "pages/Servicii/ServiciiSpeciale/CuratenieVileApartamente/sections/sections/InformationHome";
import TestimonialsHome from "pages/Homepage/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiSpeciale/CuratenieVileApartamente/sections/sections/HeroSection";
import ServicesSection from "pages/Servicii/ServiciiSpeciale/CuratenieVileApartamente/sections/sections/Services";

function CuratenieVileApartamente() {
    return (
        <>
            <Helmet>
                <title>Curățenie Vile și Apartamente | Doral Cleaning Rezidențial</title>
                <meta
                    name="description"
                    content="Oferim servicii premium de curățenie pentru locuința ta. De la garsoniere la vile spațioase, garantam un mediu curat și sigur pentru familia ta."
                />
                <link rel="canonical" href="https://doral-cleaning.ro/curatenie-vile-apartamente/" />
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "image": "",
                      "@id": "",
                      "url": "",
                      "telephone": "0730 407 322",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4, 040213 București",
                        "addressLocality": "",
                        "postalCode": "",
                        "addressCountry": ""
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      }  
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ServicesSection />
            </Card>
        </>
    );
}

export default CuratenieVileApartamente;
